import * as React from 'react';
import { TicketLineDTO, TicketLineStatus, Res } from 'core/api';
import { Result, SessionProvider } from 'core/infrastructure';
import * as Images from 'pos/Images';

import getManualCancellationReason from './getManualCancellationReason';
import { RestaurantFacade } from 'pos/facades';
import { Cols, Col, Flex } from 'core/ui';
import { Modal } from 'core/ui-next/modal';
import { ActionButtonDefinition, PosStatelessScreenClassComponent, ScreenSize } from 'pos/ui';

type Props = { reasons: string[] } & Modal.Actions<string>;

class CancellationReason extends PosStatelessScreenClassComponent<Props> {

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}

	protected useKeypad() {
		return false;
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	protected getScreenId(): string {
		return 'CANCELLATION_REASON';
	}

	protected getTitle(): string {
		return Res.Web.GET_LINE_CANCELLATION_REASON();
	}

	protected getImage(): string | SvgIcon {
		return Images.CancelTicketLine;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			{ title: Res.Common.EDIT_BTN(), image: Images.Edit, action: this.setManualReason }
		];
	}

	setManualReason = async () => {
		const result = await getManualCancellationReason();
		if (!result.ok)
			return;

		this.close(result.value);
	};

	protected getContent(): React.ReactNode {
		const reasons = this.props.reasons.map((r, idx) => {
			return <li key={idx} onClick={() => this.close(r)}>
				<Cols>
					<Col className='text-left'>
						{r}
					</Col>
				</Cols>
			</li >;
		});

		return <Flex.Vertical>
			<Flex.Item>
				<Cols className='list-header'>
					<Col width='*'>
						{Res.Web.CANCELLATION_REASONS_CLM()}
					</Col>
				</Cols>
			</Flex.Item>
			<Flex.Item size='*'>
				<ul className={'list'}>
					{reasons}
				</ul>
			</Flex.Item>
		</Flex.Vertical>;
	}
}

export default async function getCancellationReason(line: TicketLineDTO): Promise<Result<string>> {

	const session = SessionProvider.getCurrent();

	if (!session.IncludeLineCancellationReason)
		return Result.ok('');

	if (line.Status === TicketLineStatus.New && !line.HasBeenPrinted)
		return Result.ok('');

	const cancellationReasons = (await RestaurantFacade.getCancellationReasons());
	return Modal.show(CancellationReason, { reasons: cancellationReasons });
}

